<template>
    <div class="aguardando-aprovacao">
    <g-card
      class="card-aguardando-aprovacao"
      ref="cardDeBusca"
      :expansivel="true"
      :comecaFechado="false"
      margem="20px"
    >
      <template #cabecalho>
        <div class="header-filtros"> 
          <div class="titulo-filtros-cabecalho">Cartas-Proposta Aguardando Aprovação</div>
          <div class="header-icons">
            <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              v-on:acao="clear"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
            />
            <g-button
              class="buscar-button-header-filtro"
              largura="150px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="13px"
              tamanhoTexto="13px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              v-on:acao="buscar"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="consultas-aguardando-aprovacao-form espacamento-filtros">

          <div class="empresa-aguardando-aprovacao">
            <div class="titulo-conteudo-filtros">Unidade</div>
            <PDropDown
              v-model="formSearch.EmpresaId"
              :filter="true"
              :options="EmpresaArray"
              optionLabel="nome"
              optionValue="id"
              placeholder="TODAS"
              class="input-multiselect unidade"

            ></PDropDown>
          </div>

          <div class="cliente-aguardando-aprovacao">
            <div class="titulo-conteudo-filtros">Cliente</div>
            <!-- <PDropDown
              v-model="formSearch.ClienteId"
              :filter="true"
              :options="dataClientes"
              optionLabel="nomeFantasia"
              optionValue="id"
              placeholder="Selecione o Cliente"
              class="input-multiselect"
              @filter="buscarClientes($event.value)"
            >
              <template #option="slotProps">
                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
              </template>
            </PDropDown> -->
            <cliente-dropdown 
              class="input-multiselect"
              v-model="formSearch.ClienteId"
              :empresaId="formSearch.EmpresaId"
              :representanteId="this.$store.state.representanteSelecionadoId"
            />
          </div>

          <div class="numero_carta_proposta">
            <div class="titulo-conteudo-filtros">Número da Carta Proposta</div>
            <PInputText
              v-model="formSearch.NumeroCartaProposta"
              class="nome-cliente-input"
              placeholder="Insira o número da carta-proposta"
            />
          </div>

          <div class="TipoCarta">
            <div class="Tipo-Carta-Ordenacao">
              <div class="tipocarta">
                <div class="titulo-conteudo-filtros">Tipo de Carta</div>
                <PDropDown
                  v-model="formSearch.TipoCarta"
                  :filter="true"
                  :options="cartaArray"
                    optionLabel="text"
                    optionValue="enum"
                  placeholder="Selecione o tipo"
                />
              </div>
            </div>
          </div>

         <div class="data-Periodo-Emissao">
                  <div class="titulo-conteudo-filtros"> Período de Emissão </div>
                  <div class="periodo-emissao-input">
                      <div class="periodo-emissao-inicio">
                          <g-date-input
                          class="periodo-emissao-inicio-input input-label"
                          placeholderinput="Início"
                          alturainput = "40px"
                          largurainput = "100%"
                          tamanhobotao = "35px"
                          v-model="formSearch.PeriodoDeEmissaoInicio"
                          :dataPassadas="true"
                          :retornaDateTime="true"
                          ></g-date-input>
                      </div>
                      <div class="periodo-emissao-data"> à </div>
                      <div class="periodo-emissao-termino">
                          <g-date-input
                          class="periodo-emissao-termino-input input-label"
                          placeholderinput="Término"
                          alturainput = "40px"
                          largurainput = "100%"
                          tamanhobotao = "35px"
                          v-model="formSearch.PeriodoDeEmissaoFim"
                          :dataPassadas="true"
                          :retornaDateTime="true"
                          ></g-date-input>
                      </div>
                  </div>
           </div>






          <div class="data-Periodo-Baixa">
            <div class="titulo-conteudo-filtros">Status da Solicitação</div>
            <div class="status-solicitacao d-flex">
              <div class="atatus-solicitacao-input flex-grow-1">
                <PDropDown
                    class="input-multiselect"
                    v-model="formSearch.StatusSolicitacao"
                    :filter="true"
                    :options="statusSolicitacaoArray"
                    optionLabel="text"
                    optionValue="value"
                  placeholder="Selecione o Status"
                />
              </div>
            </div>
          </div>

          <div class="buscar-button-filtro">
              <g-button
              class="buscar-button"
              largura="100%"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="13px"
              tamanhoTexto="12px"
              altura="32px"
              gap="10px"
              :sombreado="false"
              @click="buscar"
              >
                  BUSCAR
              </g-button>
            </div>
        </div>
      </g-form>
      <div class="filtro_andamento d-none">FILTROS EM ANDAMENTO!</div>
    </g-card>

    <g-card paddingDefault="0 0em 1em"
      class="card-resultado"
      :expansivel="false"
      :temCabecalho="false"
    >
      <div class="card-resultado-content" v-if="mensagemvazio">
        <img
          class="icone-global-imagemfundo"
          src="@/assets/imgs/Ilustracao_erro.svg"
        />
        <div class="texto-padrao-imagemfundo">
          Verifique os filtros e click em buscar para exibir os resultados
        </div>
      </div>

      <div v-else-if="!mensagemvazio">
        <g-data-table
          TextoVazio="Nenhuma Carta-Proposta Encontrada"
          Titulo="Cartas-Proposta"
          :campoAgrupador="'razaoSocial'"
          :campoExibicaoGrupo="'labelcliente'"
          :colunas="Colunas"
          :colunaColorida="'statusSolicitacaoText'"
          :Paginacao="true"
          :GetStatusColors="'corStatusSituacaoCartaProposta'"
          :valores="OrcamentoArray"
          :NumeroLinhas="8"
          :Filtros="Filtro"
          :FiltrosEspecificos="true"
          :Editavel="false"
          :Imprimivel="false"
          :rowEditor="true"
          EscondeColunaBotao
          v-on:duploClickLinha="verificaStatus"
          altura="auto"
        ></g-data-table>
      </div>


    </g-card>

    <PDialog :closable="false" v-model:visible="MotivoAprovaPopup">
      <template #header>
      Deseja ir para Carta-Proposta?
      </template>
      <div class="container-botoes-carta-proposta">
        <div class="botao-sim">
          <g-button
            class="botao-carta-proposta"
            negritoTexto
            @click="redirecionarAprovado()">
            SIM
          </g-button>
        </div>
        <div class="botao-nao">
          <g-button
            class="botao-carta-proposta"
            tipo="cinza"
            negritoTexto
            @click="MotivoAprovaPopup = false">
            NÃO
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog :closable="false" v-model:visible="MotivoReprovaPopup">

      <template #header>
        <div class="motivo-reprova-titulo"> Motivo da Reprova</div>
      </template>
      <div class="conteudo-motivo-reprova">
        {{motivoReprova}}
      </div>

      <div class="container-botoes-carta-proposta">
        <div class="botao-sim">
          <g-button
            class="botao-carta-proposta"
            tipo="cinza"
            negritoTexto
            @click="MotivoReprovaPopup = false">
            FECHAR
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import AguardandoAprovacao from './AguardandoAprovacao.js'
export default AguardandoAprovacao
</script>

<style scoped>
.conteudo-motivo-reprova{
  align-items: center;
  text-align: center;
  color: #4e4e4e;
  /* font-weight: 600;
  font-size: 1.1rem; */
  font-weight: bold;
  align-self: center;
  margin-bottom: 20px;
}

.motivo-reprova-titulo{
  align-items: center;
  text-align: center;
  color: #4f2c19;
  font-weight: bold;
  font-size: 1.1rem;
  align-self: center;

}

:deep(.dropdown-status-solicitacao .p-dropdown){
    width: 100% !important;
}
.container-botoes-carta-proposta{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
  align-items: center;
}

.g-date-input {
  justify-content: start !important ;
}

.conteudopopupinicial {
  margin-top: 20px;
  margin-bottom: 20px;
  color: #4e4e4e;
  font-weight: 600;
  font-family: "MontSerrat";
  text-align: center;
}

.Alterar_Informacoes_Cliente {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 35px;
  grid-row-gap: 0px;
}


.card-aguardando-aprovacao-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-aguardando-aprovacao-titulo {
  color: #4f2c19;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 1.1rem;
}

.header-icons-carta {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: 100%;
    /* grid-column-gap: 10px; */
}


.imagem-nenhuma-info {
  margin: 0 36%;
  max-height: 500px;
}

.card-resultado-text {
  color: #4f2c19;
  font-family: "MontSerrat";
  font-size: 1rem;
  text-align: center;
  margin-right: 33px;
}

.card-resultado-subtext {
  color: #4f4c4d;
  font-family: "MontSerrat";
  font-size: 0.9rem;
  margin-right: 33px;
}

.secondary-text {
  display: none;
}


.container-cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.font-card {
  color: #4f2c19;
  font-size: 20px;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.buscartopo {
  display: none;
  grid-area: 1 / 1 / 2 / 2;
}

.botaobuscar {
  margin-top: 30px;
}

.botaolixo {
  grid-area: 1 / 2 / 2 / 3;
}

.g-input-label {
  margin-top: 0px;
  margin-bottom: 10px;
  display: flex;
  align-items: left;
}

.botao {
  display: flex;
  justify-content: center;
}

.p-dropdown {
  width: 100%;
}

.p-inputtext {
  width: 100%;
}

.separarinputs {
  margin-top: 15px;
}

.inputinicio {
  margin-right: 15px;
  width: 100%;
}

.inputtermino {
  margin-left: 15px;
}

.input-padrao {
  width: 100%;
}

.g-date-input {
  width: 100%;
}

.inputsdata {
  display: flex;
  justify-content: center;
}

.titulovazio {
  font-family: "MontSerrat";
  color: #4e2b18;
  font-weight: bold;
}

.subtitulovazio {
  font-family: "MontSerrat";
  color: #4f4c4d;
}

.input-multiselect {
  width: 100%;
}

.conteudovazio {
  display: inline;
}

@media (min-width: 310px) {
  .buscar-button-header {
      display: none;
  }

  .buscar-button-filtro {
    display: flex;
    justify-content: center;
    align-items: self-end;
    margin-top: 10%;
  }

  .trash-box-carta{
    margin-left: 5px;}
}

@media (min-width: 368px) {
  .buscar-button {
    width: 60%;
}

.periodo-emissao-input {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: 100%;
  grid-column-gap: 4%;
}
.periodo-emissao-inicio { grid-area: 1 / 1 / 2 / 2; }
.periodo-emissao-data { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.periodo-emissao-termino { grid-area: 1 / 3 / 2 / 4; }
}

@media (min-width: 600px) {
  .buscar-button-header {
    display: block;
    margin-left: 15px;
  }
  .buscar-button-filtro{
    margin: 0;
  }
  .buscar-button {
    display: none;
  }
}

@media (min-width: 801px) {
}

@media (min-width: 1025px) {
  .buscartopo {
    display: inline;
  }
  .botaobuscar {
    display: none;
  }
  .consultas-aguardando-aprovacao-form {
    display: grid;
    grid-template-columns: repeat(4, minmax(6em, 1fr));
    grid-template-rows: repeat(2, 50%);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    margin: 20px 20px 0 20px;
  }

  .numero_carta_proposta {
    grid-area: 1 / 3 / 2 / 4;
  }
  .empresa-aguardando-aprovacao {
    grid-area: 1 / 1 / 2 / 2;
    max-width: inherit;
  }
  .cliente-aguardando-aprovacao {
    grid-area: 1 / 2 / 2 / 3;
  }
  .TipoCarta {
    grid-area: 1 / 4 / 2 / 5;
  }
  .data-Periodo-Emissao {
    grid-area: 2 / 2 / 3 / 4;
  }

    /* Header */
  .header-icons-carta {
    display: flex;
    justify-content: right;
  }
  .card-aguardando-aprovacao-titulo {
    font-size: 22px;
}
}

@media (min-width: 1281px) {
    /* Header */
  .header-icons-carta {
    display: flex;
    justify-content: right;
  }
}

@media (min-width: 1500px) {
    /* Header */
  .header-icons-carta {
    display: flex;
    justify-content: right;
  }

    .data-Periodo-Emissao {
    grid-area: 2 / 2 / 3 / 3;
  }
}


</style>
